import { render, staticRenderFns } from "./AuthCode.vue?vue&type=template&id=29976ebc&lang=pug"
import script from "./AuthCode.vue?vue&type=script&lang=js"
export * from "./AuthCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports